module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "twitter.6f00a925.png";